<template>
  <div>
    <core-form :submit="consultaSCR">
      <v-tabs background-color="primary" dark grow v-model="tab">
        <v-tab
          v-for="(month, i) in periodos"
          :key="i" :data-cy="'periodo-' + month.split(' ')[0]">
          {{ month }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item, i) in consulta" :key="i"><PeriodoResumo v-if="item.renderizado" :value="item" @exportaBureauSCR="exportaBureauSCR"></PeriodoResumo></v-tab-item>
      </v-tabs-items>
    </core-form>
  </div>
</template>

<script>
import PeriodoResumo from './PeriodoResumo.vue'
export default {
  components: {
    PeriodoResumo
  },
  props: {
    value: null,
  },
  data () {
    return {
      periodos: [],
      consulta: [],
      model: {},
      tab: null
    }
  },
  methods: {
    consultaSCR (dtIni, dtFim) {
      const th = this
      th.$set(th, 'model', th.value)

      dtIni = th.$api.UI.Parse.Date(dtIni, 'yyyy-MM')
      let dtInicio = dtIni
      dtFim = th.$api.UI.Parse.Date(dtFim, 'yyyy-MM')

      var monthsBetween = 0

      th.periodos = []
      do {
        th.periodos.push(th.$api.UI.Format.Date(dtInicio, 'MMMM \'de\' yyyy '))
        monthsBetween++
        dtInicio = th.$api.UI.Date.AddMonth(dtInicio, 1)
      } while (dtInicio <= dtFim)

      th.consulta = Array(monthsBetween).fill({})

      var dataAtual
      if (dtIni && th.model.Documento) {
        for (let i = 0; i < monthsBetween; i++) {
          dataAtual = th.$api.UI.Format.Date(th.$api.UI.Date.AddMonth(dtIni, i), 'yyyy-MM')
          var dataBaseAno = dataAtual.split('-')[0]
          var dataBaseMes = dataAtual.split('-')[1]
          var dto = {
            consulta: {
              Documento: th.model.Documento,
              DataBaseAno: dataBaseAno,
              DataBaseMes: dataBaseMes,
            },
          }
          th.$api.Multiplo.Post('ConsultaSCR', dto).then((response) => {
            if (th.$api.UI.PostLoadData(response, true)) {
              th.$api.UTIL.Functions.SetAllButNull(th, th.consulta, i, response)
              th.$set(th.consulta[i], 'renderizado', true)
            }
          });
        }
      } else {
        if (!th.model.Documento) {
          th.$api.UI.ShowError(
            'CNPJ / CPF Inválido',
            'O documento deve ser preenchido'
          );
        }
        if (!dtInicio) {
          th.$api.UI.ShowError(
            'Período Inválido',
            'O período deve ser preenchido'
          );
        }
      }
    },
    exportaBureauSCR (tipo) {
      const th = this
      var dto = {
        labels: th.$api.Estruturadas.labelsCSVExcel,
        periodosConsulta: th.consulta
      }

      if (tipo === 1) {
        th.$api.Bureau.GerarCSVSCR(dto).then(response => {
          if (th.$api.UI.PostLoadData(response, true)) {
            th.downloadBureau(response.data, tipo)
          }
        })
      } else if (tipo === 2) {
        th.$api.Bureau.GerarExcelSCR(dto).then(response => {
          if (th.$api.UI.PostLoadData(response, true)) {
            th.downloadBureau(response.data, tipo)
          }
        })
      } else {
        th.$api.Bureau.GerarPDFSCR(dto).then(function (response) {
          if (th.$api.UI.PostLoadData(response, true)) {
            th.downloadBureau(response.data, tipo)
          }
        })
      }
    },
    downloadBureau (file, tipo) {
      var nomeArquivo = 'SCR - ' + this.value.Documento + ' - ' + this.value.DtInicio.split('-').join('/') + ' a ' + this.value.DtFim.split('-').join('/') + (tipo === 1 ? '.csv' : tipo === 2 ? '.xlsx' : '.pdf')
      var blob = tipo === 1 ? new Blob(['\ufeff', file], { type: 'text/csv' + ';charset=utf-8' }) : file;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
    }
  }
}
</script>
